module.exports={
  "Description": "BN : LLNNNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^[a-zA-Z]{2}[0-9]{4}$",
  "TestData": {
    "Valid": [
      "AB1234",
      "tK0987"
    ],
    "Invalid": [
      "abc123",
      "a12345",
	  "at123",
	  "BH12345"
    ]
  }
}